import {Button, Row} from 'reactstrap';
import './style.scss';
import {useRedirect} from "../../../../lib/utils/hooks/useRedirect";
import Logo from "../../../layout/ Logo";
import PasswordLogin from "./PasswordLogin";
import PhoneLogin from "./PhoneLogin";
import {features} from "../../../../lib/api/globalState";
import {FORM_STEPS} from "../../../../lib/utils/constants";
import ElementWithAccessInCountries from "../../../../lib/utils/hocs/ElementWithAccessInCountries";
import i18next from "i18next";
import { useApi } from '../../../../lib/api/useApi';
import { useInjection } from 'brandi-react';
import { LoginModelStoreToken } from './model';
import cross from '../../../../styles/assets/images/sv/crossBlack.svg';
import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';
import { getUpdatedRedirectUrl } from 'lib/utils/helpers/urlParseHelpers';
import {useYandexAuth} from '../../../../lib/utils/hooks/useYandexAuth';
import {useTinkoffAuth} from '../../../../lib/utils/hooks/useTinkoffAuth';
import {useVkAuth} from '../../../../lib/utils/hooks/useVkAuth'


const Login = ({isRedirectAfterLogin, formStep}) => {
    const loginModel = useInjection(LoginModelStoreToken);
    const {generateSocialMediaLink} = useApi();
    const {redirectTo} = useRedirect();
    const { t } = i18next;
    const history = useHistory()

    const isCorp = useMemo(() => new URLSearchParams(history.location.search).get('is_corp'), [history]);
    const redirectWithoutAuthUrl = useMemo(() => new URLSearchParams(history.location.search).get('redirect') || '', [history]);


    const onLoginSuccess = (v) => loginModel.onLoginSuccess(v, isRedirectAfterLogin, redirectTo);

    useYandexAuth({
        clientId: process.env.REACT_APP_YANDEX_CLIENT_ID,
        redirectUri: `${window.location.origin}/connect/yandexid/redirect`,
        buttonContainerId: 'yandexAuthButton'
    });

    useTinkoffAuth({
        clientId: process.env.REACT_APP_TINKOFF_CLIENT_ID,
        redirectUri: `${window.location.origin}/connect/tbank/redirect`,
        buttonContainerId: 'TinkoffIdSdkOneTap'
    });

    useVkAuth({
        clientId: process.env.REACT_APP_VK_CLIENT_ID,
        redirectUri: `${window.location.origin}/connect/vk/redirect`,
        buttonContainerId: 'VkIdSdkOneTap'
    });


    return <div id={'login'} className="login">
        <div className={'login-container'}>
            {isCorp && <div className="d-flex justify-content-end">
                <button onClick={() => 
                                window.location.replace(getUpdatedRedirectUrl(redirectWithoutAuthUrl))}
                                className="button_close">
                            <img src={cross} alt=""/>
                </button>            
            </div>}
            <div className="login-logo">
                <Logo />
            </div>
            {formStep === FORM_STEPS.PASSWORD_LOGIN || !features['SV-1817'] ? <PasswordLogin onLoginSuccess={onLoginSuccess} /> : <PhoneLogin onLoginSuccess={onLoginSuccess} />}
            <div className="login-text login-social-text">
                {t('common.logInVia')}
            </div>
            <Row className={'no-gutters justify-content-center'}>
                <ElementWithAccessInCountries hideInCountries={['EN']}>
                    <div id="TinkoffIdSdkOneTap" className="social-btn social-tb"></div>
                </ElementWithAccessInCountries>
                <ElementWithAccessInCountries hideInCountries={['EN']}>
                    <div id="VkIdSdkOneTap" className="social-btn social-vk"></div>
                </ElementWithAccessInCountries>
                <ElementWithAccessInCountries hideInCountries={['RU']}>
                    <Button tag={'a'} className="social-btn social-google" onClick={() => window.location.href = generateSocialMediaLink('google')} href='#'/>
                </ElementWithAccessInCountries>
                <ElementWithAccessInCountries hideInCountries={['EN']}>
                    <div id="yandexAuthButton" className="social-btn"></div>
                </ElementWithAccessInCountries>
            </Row>
        </div>
    </div>
}

export default Login;
